import React from 'react';
import IframeModal from './IframeModal';

const CreateEventIframeModal = ({ isOpen, src, onClose }) => {
  return (
    <IframeModal
      isOpen={isOpen}
      title="오픈 게임"
      iframeTitle="session-creation-wizard"
      src={src}
      heightClassName="h-[90vh] md:h-[92vh]"
      onClose={onClose}
      footer={
        <div className="shrink-0 border-t border-border px-4 py-3 bg-card">
          <button
            type="button"
            className="w-full h-11 rounded-xl border border-border bg-background hover:bg-muted transition-smooth text-sm font-semibold"
            onClick={onClose}
          >
            닫기
          </button>
        </div>
      }
    />
  );
};

export default CreateEventIframeModal;
